import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import UpdatesRoutes from './updates'
import BuzzRoutes from './buzz'
import NotificationsRoutes from './notifications'
import FeedsRoutes from './feeds'
// import TimelineRoutes from './timeline'
import SearchRoutes from './search'
import RegisterRoutes from './register'
import LoginRoutes from './login'
import OnboardingRoutes from './onboarding'
import ManageRoutes from './manage'
import DashboardRoutes from './dashboard'
import AccountRoutes from './account'
import CreateAcccountRoutes from './createaccount'
import CreateOrderRoutes from './createorder'
import SetOrderRoutes from './setorder'
//import ManageOrdersRoutes from './manageorders'
//import ManageOrderRoutes from './manageorder'
import MakeOrderRoutes from './makeorder'
import PrepareOrderRoutes from './prepareorder'
import PlacedOrdersRoutes from './placedorders'
import PlacedOrderRoutes from './placedorder'
import PlaceOrderRoutes from './placeorder'
import ShoppingListsRoutes from './shoppinglists'
import SettingsRoutes from './settings'
import CreateSellpointRoutes from './create'
import SellpointRoutes from './sellpoint'
import CollectionRoutes from './collections';
import PurchaseRoutes from './purchase'
import DemosRoutes from './demos'
import BuypointRoutes from './buypoint'
import BoxpointRoutes from './boxpoint'
import OrderpointRoutes from './orderpoint'
import ChatsRoutes from './chats'
import MyShopsRoutes from './myshops'
import TransferRoutes from './transfer'
import AgentServicesRoutes from './agentservices'
import orderpoint from './orderpoint';

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        // {
        //     path: '/.well-known/assetlinks.json',
        //     beforeEnter() {location.href = 'https://...../.well-known/assetlinks.json'}
        // },
        HomeRoutes,
        UpdatesRoutes,
        BuzzRoutes,
        NotificationsRoutes,
        FeedsRoutes,
        // TimelineRoutes,
        SearchRoutes,
        RegisterRoutes,
        LoginRoutes,
        OnboardingRoutes,
        ManageRoutes,
        PurchaseRoutes,
        DemosRoutes,
        DashboardRoutes,
        AccountRoutes,
        CreateSellpointRoutes,
        CreateAcccountRoutes,
        CreateOrderRoutes,
        SetOrderRoutes,
        MakeOrderRoutes,
        //ManageOrdersRoutes,
        //ManageOrderRoutes,
        PrepareOrderRoutes,
        PlacedOrdersRoutes,
        PlacedOrderRoutes,
        PlaceOrderRoutes,
        ShoppingListsRoutes,
        SettingsRoutes,
        CollectionRoutes,
        BuypointRoutes,
        BoxpointRoutes,
        OrderpointRoutes,
        ChatsRoutes,
        MyShopsRoutes,
        TransferRoutes,
        AgentServicesRoutes,
        //....//
        
        SellpointRoutes,
        // {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js